import { useAuth0 } from '@auth0/auth0-react';
import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useRBAC } from './contexts/rbac';
import { DetailsContainer } from './views/bee';
import { HomeView } from './views/home/home';
import { Shell } from './views/shell';

const BEE_MANAGEMENT_ROLES = ['HCM Viewer', 'HCM L3 Support', 'HCM L2 Support'];

export interface RouteParams {
  deviceId: string;
}

export const routePaths = {
  auth: {
    login: '/login',
    forgotPassword: '/forgot-password',
    verify: '/verify',
  },
  home: { root: '/home' },
  bee: { details: '/bee/:deviceId/details' },
};

export const Routes: React.FC = () => {
  const { isLoading, user, isAuthenticated, loginWithRedirect, logout } = useAuth0();
  const { roles } = useRBAC();

  if (isLoading) {
    return null;
  }

  if (!isLoading && !isAuthenticated) {
    loginWithRedirect({ redirectUri: window.location.origin });
    return null;
  }

  React.useEffect(() => {
    if (isAuthenticated && roles && !roles.some((role) => BEE_MANAGEMENT_ROLES.includes(role))) {
      logout({ returnTo: window.location.origin });
    }
  }, [roles, isAuthenticated]);

  return (
    <Route
      path="/"
      render={(r) => (
        <Shell>
          {user ? (
            <Switch>
              <Route path={routePaths.home.root} component={HomeView} />
              <Route path={routePaths.bee.details} component={DetailsContainer} />
              <Redirect path="*" to={`${r.match.url}home`} />
            </Switch>
          ) : (
            <Switch>
              <Redirect path="*" to={`${r.match.url}login`} />
              <Redirect path="*" to={`${r.match.url}home`} />
            </Switch>
          )}
        </Shell>
      )}
    />
  );
};
